import tienDoHoanThanhCv from "../views/report/qlcv/tien-do-hoan-thanh-cv";
import baoCaoTongHopThang from "../views/report/qlcv/bao-cao-tong-hop-thang";
import rankingTongHop from "../views/report/ranking/ranking-bao-cao-tong-hop-thang";
import rankingTrungBinhThang from "../views/report/ranking/ranking-bao-cao-trung-binh";
import baoCaoTinhHinhXuLyVb from "../views/report/incomingDoc/bao-cao-tinh-hinh-xu-ly-vb";
import baoCaoVbDiDaPhatHanh from "../views/report/outgoingDoc/bao-cao-vbdi-da-phat-hanh";
import baoCaoTinhHinhXuLyVbTheoDonVi from "../views/report/incomingDoc/bao-cao-tinh-hinh-xl-vb-theo-don-vi";
import hcCommandsReportIndex from "../views/report/hcCommands/hc-commands-report-index";
import hcCommandsChiTietReportIndex from "../views/report/hcCommands/hc-commands-chi-tiet-report-index";
import hcCongViecTrongTamReportIndex from "../views/report/congviectrongtam/hc-congviectrongtam-report-index";
import hcQuyCheQuyDinhReportIndex from "../views/report/quychequydinh/hc-quychequydinh-report-index";
import improperAccessCheckingService from "../services/improperAccessCheckingService";
import Constants from "../constants";

export default [
  {
    path: "/app/:userDeptRoleId/report",
    name: "reportIndex",
    component: () => import("../views/report/index.vue"),
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.BAOCAO)
    }
  },
  {
    path: "/app/:userDeptRoleId/report/docInBookReport",
    name: "docInBookReport",
    component: () => import("../views/report/docInBookReport.vue"),
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next, Constants.MENU_LIST.BAOCAO_VBTHEOSO)
    }
  },
  {
    path: "/app/:userDeptRoleId/report/vbDocReport",
    name: "vbDocReport",
    component: () => import("../views/report/vbDocReport.vue"),
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.BAOCAO_VBTHEOTRANGTHAI,
          Constants.MENU_LIST.BAOCAO_TINHHINHXLVB
      )
    }
  },
  {
    path: "/app/:userDeptRoleId/report/docInBookZipReport",
    name: "docInBookZipReport",
    component: () => import("../views/report/docInBookZipReport.vue"),
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.BAOCAO_TRICH_XUAT_VB
      )
    }
  },
  {
    path: "/app/:userDeptRoleId/report/tienDoHoanThanhCv",
    name: "tienDoHoanThanhCv",
    component: tienDoHoanThanhCv,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.BAOCAO_QLCV_TIENDOHOANTHANHCV
      )
    }
  },
  {
    path: "/app/:userDeptRoleId/report/baoCaoTongHopThang",
    name: "baoCaoTongHopThang",
    component: baoCaoTongHopThang,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.BAOCAO_QLCV_TONGHOPTHANG
      )
    }
  },
  {
    path: "/app/:userDeptRoleId/report/rankingTongHop",
    name: "rankingTongHop",
    component: rankingTongHop,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.BAOCAO_QLCV_RANKING_TONGHOP
      )
    }
  },
  {
    path: "/app/:userDeptRoleId/report/rankingTrungBinhThang",
    name: "rankingTrungBinhThang",
    component: rankingTrungBinhThang,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.BAOCAO_QLCV_RANKING_TRUNGBINHTHANG
      )
    }
  },
  {
    path: "/app/:userDeptRoleId/report/tinhHinhXuLyVb",
    name: "tinhHinhXuLyVb",
    component: baoCaoTinhHinhXuLyVb,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.BAOCAO_TINHHINHXLVB
      )
    }
  },
  {
    path: "/app/:userDeptRoleId/report/baoCaoVbDiDaPhatHanh",
    name: "baoCaoVbDiDaPhatHanh",
    component: baoCaoVbDiDaPhatHanh,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.BAOCAO_VBDIDAPHATHANH
      )
    }
  },
  {
    path: "/app/:userDeptRoleId/report/tinhHinhXuLyVanBanDenTheoDonVi",
    name: "tinhHinhXuLyVanBanDenTheoDonVi",
    component: baoCaoTinhHinhXuLyVbTheoDonVi
  },

  //theo doi chi dao lanh dao;
  {
    path: "/app/:userDeptRoleId/report/tongHopChiDao",
    name: "tongHopChiDao",
    component: hcCommandsReportIndex,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.BAOCAO_HC_CHI_DAO_TONG_HOP
      )
    }
  },
  {
    path: "/app/:userDeptRoleId/report/chiTietChiDao",
    name: "chiTietChiDao",
    component: hcCommandsChiTietReportIndex,
    async beforeEnter(to, from, next) {
      await improperAccessCheckingService.isProperAccess(to, next,
          Constants.MENU_LIST.BAOCAO_HC_CHI_DAO_CHI_TIET
      )
    }
  },
  //theo doi chi dao lanh dao:end;
  {
    path: "/app/:userDeptRoleId/report/tinhHinhCongViec",
    name: "tinhHinhCongViec",
    component: hcCongViecTrongTamReportIndex
  },
  {
    path: "/app/:userDeptRoleId/report/baoCaoQuyCheQuyDinh",
    name: "baoCaoQuyCheQuyDinh",
    component: hcQuyCheQuyDinhReportIndex
  },
];



// WEBPACK FOOTER //
// ./src/router/report.js